import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function AuthGuard({ children, requireAuth = true }) {
  const { isAuthenticated, loading, user, employee } = useAuth();

  console.log('AuthGuard check:', { loading, isAuthenticated, hasUser: !!user, hasEmployee: !!employee });

  if (loading) {
    console.log('AuthGuard: Showing loading screen');
    return (
      <div className="min-h-screen bg-[#FBF9F3] flex items-center justify-center">
        <div className="brand-card text-center py-12">
          <Loader2 className="w-12 h-12 text-[#C6A136] animate-spin mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-[#4B2E14] mb-2">
            Cargando...
          </h3>
        </div>
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    console.log('AuthGuard: Redirecting to login (not authenticated)');
    return <Navigate to="/login" replace />;
  }

  if (!requireAuth && isAuthenticated) {
    console.log('AuthGuard: Redirecting to home (already authenticated)');
    return <Navigate to="/" replace />;
  }

  console.log('AuthGuard: Rendering children');
  return <>{children}</>;
}